import { useOnMount } from '@base-ui/utils/useOnMount';
import { useStore } from '@base-ui/utils/store/useStore';
import { useEventCalendarStoreContext } from "../use-event-calendar-store-context/index.mjs";

/**
 * Initializes the view on the event calendar.
 * The initialization is only done during the 1st render, the config should be defined statically.
 * ```
 * @param parameters Parameters for the view.
 */
export function useEventCalendarView(config) {
  // Context hooks
  const store = useEventCalendarStoreContext();

  // Selector hooks
  const days = useStore(store, config.visibleDaysSelector);

  // Feature hooks
  useOnMount(() => store.setViewConfig(config));
  return {
    days
  };
}